import type { BeforeSend, BeforeSendEvent, SpeedInsightsProps } from '../types';
import { createComponent } from './create-component';

export const SpeedInsights = createComponent();
export type { SpeedInsightsProps, BeforeSend, BeforeSendEvent };
